<template>
  <div>
    <v-overlay :value="showLoader">
      <v-progress-circular
        indeterminate
        color="primary"
        :size="70"
        :width="7"
      ></v-progress-circular>
    </v-overlay>    
    <v-dialog v-model="dialog" max-width="750px">
        <v-card>            
          <affiliate-card v-if="selectedAffiliate" :affiliate="selectedAffiliate" />
        </v-card>
    </v-dialog>
    <v-sheet color="white" elevation="5" rounded class="mt-5 mb-5 pt-3 pb-5 pl-3 pr-3">
      <v-row>
        <h1 class="ma-3 text-center">Affiliates Listing</h1>
      </v-row>    
      <v-row class="pa-3">
        <v-col>
          <v-row>
            <v-col>
            <v-autocomplete 
                v-model="selectedCountries"
                label="Select Countries"
                :items="countries"
                clearable
                multiple/>
            </v-col> 
            <v-col>
            <v-autocomplete 
                v-model="selectedStates"
                label="Select States (US only)"
                :items="states"
                clearable
                multiple/>
            </v-col>  
          </v-row> 
        </v-col>
        <v-spacer/>
            <v-col>
              <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details />
            </v-col>  
            <v-col cols="1">            
              <v-btn outlined color="primary" :disabled="filteredAffiliates?.length == 0"
                    v-on:click="csvExport()">
                  <font-awesome-icon icon="file-download" size="lg" />
              </v-btn>
            </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-data-table :headers="affiliatesListingHeaders" :items="filteredAffiliates" :search="search" dense 
            :sort-by="['country', 'region']" :sort-desc="[true, false]" :items-per-page="-1" fixed-header 
            show-group-by          
            @current-items="currentItemsUpdate">   
            <template v-slot:[`item.actions`]="{ item }">   
              <span>
                <v-icon small v-on:click="() => {selectedAffiliate = item; dialog = true;}"> mdi-information </v-icon>                
              </span>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
  </v-sheet>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { getUserToday } from "@/helpers/date-utils";
import AffiliateCard from "@/components/Portal/AffiliateCard.vue";
import affiliateService from "@/services/portal/affiliateService";

export default Vue.extend({
  components: { AffiliateCard },
  name: "AffiliateList",
  data: function () {
    return {
      affiliates: [] as any [],
      currentItems: [] as any [],
      countries: [] as string [],
      states: [] as string [],
      selectedCountries: [] as string [],
      selectedStates: [] as string [],
      showLoader: false,
      search: "",
      dialog: false,
      selectedAffiliate: null as any | null,
      affiliatesListingHeaders: [
        { text: "Country", align: "left", value: "country" },
        { text: "State", align: "left", value: "region" },
        { text: "Club Name", align: "left", value: "name",  groupable: false },
        { text: "Club Website", align: "left", value: "clubSite", groupable: false },
        { text: "Affiliate Representative", align: "left", value: "contact.name", groupable: false },
        { text: "Representative Email", align: "left", value: "contact.email", groupable: false },
        { text: "Representative Phone", align: "left", value: "contact.phoneNumber", groupable: false },
        { text: "More", value: "actions", sortable: false, groupable: false },
      ],
    };
  },
  created: function () {
    this.showLoader = true;
    affiliateService.getAffiliates().then((res: any) => {
      this.$data.affiliates = res.affiliates;
      this.$data.states = [
        ...this.$data.states,
        ...res.states,
      ];
      this.$data.countries = [
        ...this.$data.countries,
        ...res.countries,
      ];
      this.showLoader = false;
    });
  },
  computed: {
    filteredAffiliates() {
      if(this.$data.selectedCountries.length === 0 && this.$data.selectedStates.length === 0)
        this.$data.affiliates;      
      const filteredByCountries = this.$data.selectedCountries.length === 0 ? 
        this.$data.affiliates
        : this.$data.affiliates.filter((affiliate: { country: string }) =>
            this.$data.selectedCountries.includes(affiliate.country)
      );
      const filteredByStates = this.$data.selectedStates.length === 0 ?           
        filteredByCountries
        : filteredByCountries.filter((affiliate: { state: string }) =>
            this.$data.selectedStates.includes(affiliate.state)
      );
      return filteredByStates;
    },
  },
  methods: { 
    csvExport: function () {
        var filename = `AffiliatesListing_${getUserToday()}.csv`;
        var content = this.currentItems;
        const keys = ['Country', 'Region', 'Name', 'Website', 'Affiliate Representative', 'Representative Email', 'Representative Phone', 'President', 'President Email', 'President Phone',];
        const commaSeparatedString = [keys.join(","), 
          content.map((row: any) => 
          [row.country, row.region, row.name, row.clubSite, row.contact.name, row.contact.email, row.contact.phoneNumber, row.president.name, row.president.email, row.president.phoneNumber].join(",")).join("\n")].join("\n")
        const csvBlob = new Blob([commaSeparatedString])
        var link = document.createElement("a");
        var url = URL.createObjectURL(csvBlob);
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    },  
    currentItemsUpdate: function(value: any){
      this.currentItems = value;
    },
  },
  watch: {
      dialog(val) {
        if (!val) {
          this.selectedAffiliate = null;
          this.dialog = false;
        }
      },
  },
});
</script>
